import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=b0e2abba&scoped=true&"
import script from "./AppError.vue?vue&type=script&lang=js&"
export * from "./AppError.vue?vue&type=script&lang=js&"
import style0 from "./AppError.vue?vue&type=style&index=0&id=b0e2abba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e2abba",
  null
  
)

export default component.exports